import { render } from "./Personalities.vue?vue&type=template&id=d58d2d7a"
import script from "./Personalities.vue?vue&type=script&lang=js"
export * from "./Personalities.vue?vue&type=script&lang=js"

import exportComponent from "../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__